import {
  Divider,
  DrawerBody,
  Flex,
  HStack,
  Link,
  Stack,
  Text,
} from '@chakra-ui/react';
import { PaymentMethods } from 'shared/types/payment';
import { useCreateContractModalContext } from '../modals/CreateContractModal/ModalContext';
import { ContractModalFooter } from '../molecules';
import { PlanDetailsCard } from '../molecules/PlanDetailsCard';
import AddedServicesList from './AddedServicesList';

interface ContractReviewStepProps {
  onClose: () => void;
}

const labelOf = (periodicity?: string) =>
  periodicity === 'yearly'
    ? 'Anual'
    : periodicity === 'monthly'
      ? 'Mensal'
      : '-';

const ContractReviewStep: React.FC<ContractReviewStepProps> = ({ onClose }) => {
  const {
    contract,
    paymentMethod,
    periodicity,
    getUpsellPrice,
    paymentDay,
    loading,
    handleSubmit,
    addedProducts,
    setStep,
    selectedContractType,
  } = useCreateContractModalContext();

  const upsellRulesLink =
    'https://www.notion.so/Clusteriza-o-de-Upsell-2a1f37240ee641c086083f908cdd5339';

  const getMainService = () => {
    const plan = addedProducts.filter((product) => {
      return product.selectedService?.is_license;
    });

    if (!plan.length) {
      return;
    }

    return plan[0].selectedService;
  };

  const periodicityLabel = labelOf(periodicity);
  const mainService = getMainService();
  const planName = mainService?.name ?? '-';
  const planPrice = mainService?.value ?? 0;

  const onEditPlan = () => setStep?.(1);

  return (
    <Flex
      direction="column"
      flex={1}
      minH={0}
      overflow="hidden"
      justify="space-between"
      px={4}
    >
      <DrawerBody scrollBehavior="auto">
        <Stack py="1rem" spacing="6">
          <Text fontWeight="semibold" fontSize="1.25rem">
            Pré-visualização do Contrato
          </Text>

          {planName !== '-' && (
            <PlanDetailsCard
              periodicityLabel={periodicityLabel}
              planName={planName}
              planPrice={planPrice}
              onEdit={onEditPlan}
            />
          )}

          {!!contract && periodicity === 'monthly' && (
            <Flex bg="red.50" color="red.800" p="3" borderRadius="md">
              <Text fontSize="sm">
                <strong>Atenção!</strong> Uma cobrança de{' '}
                <strong>{getUpsellPrice()}</strong> será criada a partir das
                regras de upsell da Yooga.{' '}
                <Link
                  href={upsellRulesLink}
                  target="_blank"
                  textDecoration="underline"
                >
                  Veja as regras.
                </Link>
              </Text>
            </Flex>
          )}

          <Divider />

          <HStack spacing={1} justifyContent={'space-between'}>
            <Flex gap={2} maxW="280px">
              <Text fontSize="1rem" fontWeight="semibold">
                Tipo:
              </Text>
              <Text fontSize="md">{selectedContractType?.label}</Text>
            </Flex>

            <Flex gap={2} maxW="280px">
              <Text fontSize="1rem" fontWeight="semibold">
                Pagamento:
              </Text>
              <Text fontSize="md">
                {contract
                  ? contract.paymentMethodName
                  : PaymentMethods[paymentMethod]}
              </Text>
            </Flex>

            {!contract && (
              <Flex gap={2} maxW="280px">
                <Text fontSize="1rem" fontWeight="semibold">
                  Vencimento:
                </Text>
                <Text fontSize="md">{paymentDay}</Text>
              </Flex>
            )}
          </HStack>

          <Divider />

          <Text fontWeight="semibold" fontSize="1.25rem">
            Todos os itens selecionados
          </Text>

          <AddedServicesList
            variant="simple"
            showDiscount={false}
            showRemove={false}
            showEdit
            onEditService={() => setStep?.(1)}
          />
        </Stack>
      </DrawerBody>

      <ContractModalFooter
        onCancel={onClose}
        onNext={handleSubmit}
        isNextDisabled={loading}
        nextLabel={!contract ? 'Concluir contrato' : 'Adicionar serviços'}
      />
    </Flex>
  );
};

export default ContractReviewStep;
